import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

interface AuthPromptProps {
  onSignUp: () => void;
  onLogin: () => void;
  remainingMessages?: number | null;
  language: string;
}

const AuthPrompt: React.FC<AuthPromptProps> = ({ 
  onSignUp, 
  onLogin, 
  remainingMessages,
  language 
}) => {
  const { t } = useTranslation(language);

  return (
    <div className="auth-prompt">
      <div className="auth-prompt-content">
        <div className="auth-prompt-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#FFA500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8V12" stroke="#FFA500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 16H12.01" stroke="#FFA500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h3 className="auth-prompt-title">
          {remainingMessages !== null && remainingMessages <= 0 
            ? t('auth.limitReached') 
            : t('auth.signUpToday')}
        </h3>
        
        <p className="auth-prompt-message">
          {remainingMessages !== null && remainingMessages <= 0
            ? t('auth.limitMessage')
            : t('auth.benefitsMessage')}
        </p>

        {/* Removed remaining messages display as per requirement */}

        <div className="auth-prompt-buttons">
          <button onClick={onSignUp} className="auth-btn auth-btn-primary">
            {t('auth.signUp')}
          </button>
          <button onClick={onLogin} className="auth-btn auth-btn-secondary">
            {t('auth.login')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthPrompt;